module.exports = __webpack_public_path__ + "img/bonus.0db3a4b4.gif";